import React from 'react'
import s from './DefaultBlock.less'

const DefaultBlock = props => {
  return __DEV__ ? <div className={s.root}>Block inconnu {props.data.type}</div> : null
}

export default DefaultBlock
